module.exports = __webpack_public_path__ + "img/plane_incorrect.f8708f72.svg";